module.exports = __webpack_public_path__ + "img/oro-spinner.7c628130.gif";